import { Logout } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { logout } from '@/pages/auth/model/logout';

const LogoutButton = () => {
  const { t } = useTranslation();

  return (
    <Button
      sx={{
        width: '100%',
        textAlign: 'left',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        px: 2,
        gap: 1,
        textTransform: 'none',
      }}
      variant="text"
      color="error"
      onClick={logout}
    >
      <Logout fontSize="small" />
      {t('common.Actions.Logout', { defaultValue: 'Logout' })}
    </Button>
  );
};

export default LogoutButton;
